import { useQuery } from '@apollo/client/react';
import { faUserPen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';
import { Controller } from 'react-hook-form';
import { withTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
import AsyncSelectCreatable from 'react-select/async-creatable';

import styles from '../Select/style';
import UserTag from '../UserTag';

import GetUsersQuery from './GetUsersQuery.graphql';

import * as style from './style.module.css';

const formatUserLabel = (data) => {
  if (!data.member) {
    return <div className={style.externalUser}>
      <FontAwesomeIcon icon={faUserPen} /> {data.memberName || data.label}
    </div>
  }
  return <div className={style.user}>
    <UserTag {...data.member} inline />
  </div>
}

const UserSelect = ({ t, allowCustomUser = false, control, register = {}, ...rest }) => {
  const timeout = useRef(null);

  const { refetch: getUsersQuery } = useQuery(GetUsersQuery, { skip: true });

  const handleSearch = (inputValue) => new Promise((resolve) => {
    clearTimeout(timeout?.current);
    timeout.current = setTimeout(async () => {
      const data = await getUsersQuery({
        filter: { text: inputValue }
      });

      return resolve(data?.data?.users?.edges?.map(e => ({
        value: `user-${e.node.id}`,
        label: e.node.login,
        member: e.node,
        memberName: ''
      })));
    }, 250);
  });

  const Select = allowCustomUser ? AsyncSelectCreatable : AsyncSelect;
  const renderController = ({ field: { value, onChange, onBlur } }) => {
    return (
      <Select
        value={value}
        menuPortalTarget={document.querySelector("body")}
        classNamePrefix="react-select"
        styles={styles}
        type="text"
        onChange={(val) => onChange({
          value: `user-${val.member.id}`,
          label: val.member.login,
          member: val.member,
          memberName: ''
        })}
        onCreateOption={(val) => onChange({
          value: `custom-${val}`,
          label: val,
          member: null,
          memberName: val
        })}
        createOptionPosition="last"
        loadingPlaceholder={() => t('Loading…')}
        noOptionsMessage={() => t('No users')}
        formatCreateLabel={(v) => v}
        onBlur={onBlur}
        options={[]}
        formatOptionLabel={formatUserLabel}
        loadOptions={handleSearch}
        {...rest}
      />
    );
  };

  return <Controller name={register?.name} control={control} render={renderController} />;
};

export default React.memo(withTranslation()(UserSelect));
